import React, { useEffect, useState } from "react";
import { IP } from "../../../internalServer";
import { iconData } from "../../../iconData";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";

// ===== Helpers =====
const getFileType = (fileUrl) => {
  if (!fileUrl || typeof fileUrl !== "string") return "";
  const parts = fileUrl.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};
const isImageFile = (url) => ["jpg", "jpeg", "png"].includes(getFileType(url));
const isVideoFile = (url) => ["mp4", "mov"].includes(getFileType(url));
const isPdfFile = (url) => getFileType(url) === "pdf";
const getFileIcon = (url) =>
  iconData?.find((i) => i.extension === getFileType(url))?.icon ||
  "/images/file_icon.png";
const truncate = (text, max = 15) =>
  text?.length > max ? text.slice(0, max) + "..." : text;

export default function CheckBoxType({
  questionNo,
  setQuestionsAnswer,
  responseAnswers,
  type,
  questionsAnswer,
  isNextQuestion,
}) {
  const [isClicked, setIsClicked] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState(null);

  const currentAnswer = questionsAnswer[questionNo - 1];
  const question = currentAnswer?.b4sQuestion || currentAnswer?.question;

  const handleCheckboxChange = (e) => {
    const selectedKey = e.target.value;
    setQuestionsAnswer((prev) =>
      prev.map((item, index) => {
        if (index !== questionNo - 1) return item;
        const options = item?.question?.options || item?.b4sQuestion?.options;
        const selectedOption = options?.find((opt) => opt.key === selectedKey);
        return {
          ...item,
          answer: {
            ...item.answer,
            key: selectedKey,
            explanation: selectedOption?.value || "",
          },
        };
      }),
    );
  };

  useEffect(() => {
    setQuestionsAnswer((prev) =>
      prev.map((item, index) =>
        index === questionNo - 1
          ? { ...item, answer: { key: "", explanation: "" } }
          : item,
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNextQuestion]);

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked((v) => !v);
  };

  const handleClickforpdf = (filePath) => {
    setTimeout(() => {
      setResponseAttach(filePath);
      setMideaviewer(true);
    }, 100);
  };

  const renderAttachment = (attachment, idx, onClickHandler) => {
    const fileUrl =
      typeof attachment === "string" ? attachment : attachment?.url;
    if (!fileUrl) return null;

    if (isImageFile(fileUrl)) {
      return (
        <img
          key={idx}
          style={{ cursor: "pointer" }}
          className="mt-3 imageWidthAndHeight"
          src={IP + fileUrl.replace(/^\./, "")}
          alt="Attachment"
          onClick={() => {
            if (!isError) handleClick(fileUrl);
          }}
        />
      );
    }

    return (
      <div
        key={idx}
        onClick={() => onClickHandler(fileUrl)}
        style={{
          width: "100px",
          height: "50px",
          background: "#f5f5f5",
          borderRadius: "6px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "6px 0px",
          gap: "6px",
        }}
      >
        <img
          src={getFileIcon(fileUrl)}
          alt="file"
          style={{ width: "24px", height: "24px" }}
        />
        <div className="hw_default_attach_name">
          <span>{truncate(fileUrl.replace(/^[^_]*_/, ""), 15)}</span>
        </div>
      </div>
    );
  };

  const questionAttachments =
    type === "SA"
      ? question?.attachments || []
      : currentAnswer?.question?.attachments || [];

  const options =
    type === "SA"
      ? question?.options || []
      : currentAnswer?.b4sQuestion?.options || [];

  return (
    <>
      <div className="containerBelowQuestion">
        {/* ===== Question Title ===== */}
        <div className="flex justify-between">
          <div className="text-[15px] font-semibold text-slate-800 leading-relaxed">
            {"Q" + questionNo + ". "}
            {(type === "SA" ? question?.title : currentAnswer?.question?.title)
              ?.split("\n")
              .map((line, index) => (
                <React.Fragment key={index}>
                  {index !== 0 && <br />}
                  <span
                    style={
                      index !== 0
                        ? { marginLeft: "30px", display: "inline-block" }
                        : {}
                    }
                  >
                    {line}
                  </span>
                </React.Fragment>
              ))}

            {(type === "SA"
              ? question?.is_mandatory
              : currentAnswer?.question?.is_mandatory) && (
              <span className="ml-3 inline-block px-2 py-0.5 rounded bg-red-50 text-red-700 text-[10px] font-bold uppercase tracking-wide">
                * Mandatory
              </span>
            )}
          </div>
        </div>

        {/* ===== Question Attachments ===== */}
        {questionAttachments.length > 0 &&
          questionAttachments.map((attachment, index) =>
            renderAttachment(attachment, index, handleClickforpdf),
          )}

        {/* ===== Options ===== */}
        <div className="mt-5 space-y-2.5">
          {options.map((option, index) => {
            const isSelected = option?.key === currentAnswer?.answer?.key;
            const optionAttachment = option?.attachment;

            return (
              <React.Fragment key={option?.key ?? index}>
                <div
                  onClick={() =>
                    type === "SA" &&
                    handleCheckboxChange({ target: { value: option.key } })
                  }
                  className={[
                    "flex items-center justify-between gap-3 px-4 py-3 rounded-lg border-[1.5px] transition-all cursor-pointer",
                    isSelected
                      ? "border-emerald-400 bg-emerald-50/50"
                      : "border-slate-200 bg-white hover:border-orange-300 hover:bg-orange-50/30",
                  ].join(" ")}
                >
                  <div className="flex items-center gap-3 min-w-0">
                    {/* Custom checkbox */}
                    <div
                      className={[
                        "w-5 h-5 rounded flex items-center justify-center flex-shrink-0 border-2 transition-all",
                        isSelected
                          ? "bg-emerald-500 border-emerald-500"
                          : "bg-white border-slate-300",
                      ].join(" ")}
                    >
                      {isSelected && (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M5 13L9 17L19 7"
                            stroke="#fff"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                    <input
                      type="checkbox"
                      className="sr-only"
                      name={`question_${questionNo}`}
                      value={option?.key}
                      checked={isSelected}
                      onChange={handleCheckboxChange}
                      readOnly={type !== "SA"}
                    />
                    <span
                      className={[
                        "text-sm break-words",
                        isSelected
                          ? "text-slate-800 font-medium"
                          : "text-slate-600",
                      ].join(" ")}
                    >
                      {option?.value}
                    </span>
                  </div>

                  {isSelected && type !== "SA" && (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-semibold uppercase tracking-wide whitespace-nowrap">
                      Your answer
                    </span>
                  )}
                </div>

                {optionAttachment && (
                  <div className="ml-11 mt-1.5">
                    {renderOptionAttachment(
                      optionAttachment,
                      handleClickforpdf,
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {/* PDF / Media viewer */}
      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {/* Full-size image/video modal */}
      {isClicked && responseAttach && (
        <FullSizeMediaModal
          responseAttach={responseAttach}
          isError={isError}
          setIsError={setIsError}
          onClose={handleClick}
        />
      )}
    </>
  );
}

// ===== Option attachment renderer =====
function renderOptionAttachment(attachment, onPdfClick) {
  const fileUrl = typeof attachment === "string" ? attachment : attachment?.url;
  if (!fileUrl) return null;

  const fullUrl = fileUrl.startsWith("http") ? fileUrl : `${IP}${fileUrl}`;

  if (isImageFile(fileUrl)) {
    return <ZoomableImage src={attachment} />;
  }

  if (isVideoFile(fileUrl)) {
    return (
      <video
        src={fullUrl}
        style={{
          width: "60px",
          height: "50px",
          borderRadius: "6px",
          marginBottom: "5px",
        }}
        controls
      />
    );
  }

  if (isPdfFile(fileUrl)) {
    return (
      <div
        onClick={() => onPdfClick(fileUrl)}
        style={{
          width: "100px",
          height: "50px",
          background: "#f5f5f5",
          borderRadius: "6px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "6px 0px",
        }}
      >
        <img
          src={getFileIcon(fileUrl)}
          alt="pdf"
          style={{ width: "24px", height: "24px" }}
        />
        <div className="hw_default_attach_name">
          <span>{truncate(fileUrl.replace(/^[^_]*_/, ""), 15)}</span>
        </div>
      </div>
    );
  }

  return (
    <a
      href={`https://docs.google.com/gview?url=${encodeURIComponent(
        fullUrl,
      )}&embedded=true`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <div
        style={{
          width: "100px",
          height: "50px",
          background: "#f5f5f5",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={getFileIcon(fileUrl)}
          alt="file"
          style={{ width: "24px", height: "24px" }}
        />
      </div>
    </a>
  );
}

// ===== Full-size media modal =====
function FullSizeMediaModal({ responseAttach, isError, setIsError, onClose }) {
  if (!responseAttach) return null;
  const ext = responseAttach.split(".").pop()?.toLowerCase();

  if (ext === "mp4") {
    return (
      <div className="fullSizeImg">
        <div className="SubfullSizeImg">
          <video className="videoPlayer" controls>
            <source
              src={IP + responseAttach.replace(/^\./, "")}
              type="video/mp4"
            />
          </video>
          <div>
            <img
              className="crossIconImgQue"
              onClick={onClose}
              src="/DCM-img/crossIcon.svg"
              alt="Close"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fullSizeImg">
      <div className="SubfullSizeImg">
        {!isError ? (
          <>
            <img
              className="imgMain"
              src={IP + responseAttach.replace(/^\./, "")}
              alt="Full-size"
              onError={() => setIsError(true)}
            />
            <div>
              <img
                className="crossIconImgQue"
                onClick={onClose}
                src="/images/cross.png"
                alt="Close"
              />
            </div>
          </>
        ) : (
          <div
            className="fullSizeImg"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <img
              onClick={() => {
                setIsError(false);
                onClose();
              }}
              src="/images/cross.png"
              alt="Close"
              style={{ position: "absolute", top: "75px", right: "40%" }}
            />
            <img
              src="/images/no-photo1.png"
              alt="img"
              style={{ width: "25%" }}
            />
            <p
              style={{
                color: "red",
                fontSize: "20px",
                fontWeight: "500",
                marginRight: "35px",
              }}
            >
              Error!! failed to load the requested file!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
